import React from 'react';
import {images} from '../../constants'
import { GiHamburgerMenu } from 'react-icons/gi';
import { MdOutlineRestaurantMenu } from 'react-icons/md';
import './Navbar.css';

const Navbar = () => {
  const [toggleMenu, setToggleMenu] = React.useState(false)
  return(
    <nav>
    <div className="nav-logo">
      <img src={images.gericht} alt="logo" />
    </div>
    <ul className='nav-links'>
      <li><a className="p__opensans" href="#home">home</a></li>
      <li><a className="p__opensans" href="#about">about</a></li>
      <li><a className="p__opensans" href="#menu">menu</a></li>
      <li><a className="p__opensans" href="#awards">awards</a></li>
      <li><a className="p__opensans" href="#contact">contact</a></li>
    </ul>
    <div className="login">
      <a className="p__opensans" href="#login">Log In / Registration</a>
      <div />
      <a className="p__opensans" href="/">Book Table</a>
    </div>

    <div className="nav-ss">
      <GiHamburgerMenu color='#fff' className='menuu' fontSize={27} onClick={()=> setToggleMenu(true)}/>
      {toggleMenu && (
        <div className="nav-overlay flex__center slide-bottom">
          <MdOutlineRestaurantMenu fontSize={27} className='overlay-close' onClick={()=>setToggleMenu(false)}/>
          <ul className="nav-links-ss">
            <li><a href="#home" onClick={()=>setToggleMenu(false)}>home</a></li>
            <li><a href="#about" onClick={()=>setToggleMenu(false)}>about</a></li>
            <li><a href="#menu" onClick={()=>setToggleMenu(false)}>menu</a></li>
            <li><a href="#awards" onClick={()=>setToggleMenu(false)}>awards</a></li>
            <li><a href="#contact" onClick={()=>setToggleMenu(false)}>contact</a></li>
          </ul>
        </div>
      )
      }
    </div>
  </nav>
  )
};

export default Navbar;
